<div class="reports">
    <router-outlet></router-outlet>
</div>